import { MarketplaceTabGroup } from '../../../../../utils/tabGroupDividers';

export enum BuyerOppMarketplaceTab {
    Timeline = 1,
    DeadlineDocket = 2,
    Documents = 3,
    CommsHub = 4,
    EngagementHistory = 5,
    DealTeam = 6,
    DataRoom = 7,
    SellerProfile = 8,
    ProcessCommercialTerms = 9,
    LoiSubmissionPackage = 10,
    FlowOfFunds = 11,
}

export const BuyerOppMarketplaceTabs = [
    {
        id: BuyerOppMarketplaceTab.EngagementHistory,
        content: 'Engagement History',
        group: MarketplaceTabGroup.Engagement,
    },
    {
        id: BuyerOppMarketplaceTab.Documents,
        content: 'Engagement Documents',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.Timeline,
        content: 'Timeline',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DeadlineDocket,
        content: 'Deadline Docket',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.SellerProfile,
        content: 'Seller Profile',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DealTeam,
        content: 'Deal Team',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.CommsHub,
        content: 'Comms Hub',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.ProcessCommercialTerms,
        content: 'Buyer Fee Schedule',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.LoiSubmissionPackage,
        content: 'LOI Submission Package',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.FlowOfFunds,
        content: 'Flow of Funds',
        group: MarketplaceTabGroup.DealWorkspace,
    },
    {
        id: BuyerOppMarketplaceTab.DataRoom,
        content: 'Data Room',
        group: MarketplaceTabGroup.ClosingAndBeyond,
    },
];

export const BuyerOppMarketplaceDefaultTabPreference = [
    BuyerOppMarketplaceTab.Timeline,
    BuyerOppMarketplaceTab.DeadlineDocket,
    BuyerOppMarketplaceTab.Documents,
    BuyerOppMarketplaceTab.CommsHub,
    BuyerOppMarketplaceTab.EngagementHistory,
    BuyerOppMarketplaceTab.DealTeam,
    BuyerOppMarketplaceTab.DataRoom,
    BuyerOppMarketplaceTab.SellerProfile,
    BuyerOppMarketplaceTab.ProcessCommercialTerms,
    BuyerOppMarketplaceTab.LoiSubmissionPackage,
    BuyerOppMarketplaceTab.FlowOfFunds,
];
